import { render } from "./system-settings-modal.vue?vue&type=template&id=39bcfe9d"
import script from "./system-settings-modal.vue?vue&type=script&lang=js"
export * from "./system-settings-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__